module.exports = __webpack_public_path__ + "static/img/blscH5.09816b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blscH5.png
// module id = Oxe1
// module chunks = 0